<div class="reason-section-title">Reason</div>

@if (paymentReasons.length) {
  <div class="payment-reasons">
    @for (paymentReason of paymentReasons; track paymentReason) {
      <div class="payment-reason-item" [class.disabled]="isMoveFieldsDisabled">
        <label [for]="paymentReason.id" class="payment-reason-radio-input-label">
          <span class="payment-reason-radio-input" [class.checked]="paymentReasonField.value === paymentReason.id"></span>
          <input
            hidden
            [id]="paymentReason.id"
            [value]="paymentReason.id"
            [formControl]="paymentReasonField"
            [appFieldDisable]="isMoveFieldsDisabled"
            (change)="onPaymentReasonSelect(paymentReason)"
            name="payment-reason"
            type="radio"
            class="form-check-input"
          />
          <span class="payment-reason-item-value" [title]="paymentReason.reason">
            {{ paymentReason.reason }}
          </span>
        </label>
      </div>
    }
  </div>
} @else {
  <div class="payment-reasons"></div>
}
